// eslint-disable-next-line import/no-anonymous-default-export
export default (state: any, action: any) => {
  switch (action.type) {
    case "SET_USE_CASE":
      return {
        ...state,
        useCase: action.payload.useCase,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    case "SET_RISK_LEVELS":
      return {
        ...state,
        riskLevels: action.payload.riskLevels,
      };
    case "SET_PRODUCTS":
      return {
        ...state,
        products: action.payload.products,
      };

    case "SET_CASE_ROLES":
      return {
        ...state,
        caseRoles: action.payload.caseRoles,
      };

    case "SET_LANDS":
      return {
        ...state,
        lands: action.payload.lands,
      };

    case "SET_BRANCHES":
      return {
        ...state,
        branches: action.payload.branches,
      };

    case "SET_AREAS":
      return {
        ...state,
        areas: action.payload.areas,
      };

    case "SET_OPERATIONS":
      return {
        ...state,
        operations: action.payload.operations,
      };

    case "SET_ALGORITHMS":
      return {
        ...state,
        algorithms: action.payload.algorithms,
      };

    case "SET_TECHNIQUES":
      return {
        ...state,
        techniques: action.payload.techniques,
      };
    case "SET_MACHINE_LEARNING_TYPES":
      return {
        ...state,
        machineLearningTypes: action.payload.machineLearningTypes,
      };

    case "SET_ROLE":
      return {
        ...state,
        role: action.payload.role,
      };
    default:
      return state;
  }
};
